import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

/**
 * Status da aba "Cadastro e Recebimento":
 *   - enabled: flag admin (companies.cadastro_recebimento_enabled). Quando
 *              false, a aba some do menu e a rota mostra mensagem amigavel.
 *   - hasV3:   empresa tem Tiny v3 conectado. As 3 sub-tabs continuam
 *              visiveis; Cadastro e Importar XML so mostram banner de
 *              aviso sobre conflito potencial com sync.
 */
interface Status {
  loading: boolean
  enabled: boolean
  hasV3: boolean
}

export function useCadastroRecebimentoStatus(): Status {
  const [state, setState] = useState<Status>({
    loading: true,
    enabled: true,
    hasV3: false,
  })

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) { if (!cancelled) setState(s => ({ ...s, loading: false })); return }
      const { data: profile } = await supabase
        .from('profiles').select('company_id').eq('id', user.id).single()
      const cid = profile?.company_id as string | undefined
      if (!cid) { if (!cancelled) setState(s => ({ ...s, loading: false })); return }
      const { data: company } = await supabase
        .from('companies')
        .select('tiny_v3_connected_at, cadastro_recebimento_enabled')
        .eq('id', cid).single()
      if (cancelled) return
      setState({
        loading: false,
        enabled: company?.cadastro_recebimento_enabled !== false,
        hasV3: !!company?.tiny_v3_connected_at,
      })
    })()
    return () => { cancelled = true }
  }, [])

  return state
}
